import BaseAPIService from '../base/base-api-service';
import CheckoutModel from 'src/model/checkout.model';

export interface IShippingMethod {
  motcode: string;
  motdescription: string;
}

class CheckoutService extends BaseAPIService<CheckoutModel> {
  private endpoint: string = '/cartapp/v1';

  private CHECKOUT_ENDPOINT: string = '/orders/checkout';
  private SHIPPING_METHOD_ENDPOINT: string = '/ship/method';
  private PLACE_ORDER_ENDPOINT: string = '/orders/place';
  private CONFIRM_ORDER_ENDPOINT: string = '/orders/confirm';

  constructor() {
    super(CheckoutModel);
  }

  public getCheckout(): Promise<CheckoutModel> {
    return this.getOneByParams(`${this.endpoint}${this.CHECKOUT_ENDPOINT}`);
  }

  public getShippingMethods(isDelivery: boolean): Promise<IShippingMethod[]> {
    return this.doRequest({
      baseURL: this.baseURL,
      url: `${this.endpoint}${this.SHIPPING_METHOD_ENDPOINT}?isDelivery=${isDelivery}`
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error(error);
        throw error;
      });
  }

  public placeOrder(
    checkoutCode: number,
    confirmationEmail: boolean,
    deliverSameTime: boolean,
    paymentMethod: string,
    poNumber: string,
    shippingMethod: string,
    unit: string,
    serviceOrder: string,
    techId: string,
    mobileNumber: string,
    emailId: string,
    isOrderEmailPhoneUpdated: boolean,
    OrderTemprary: any
  ): Promise<{
    pendingOrderNumber: number;
    totalToBePaid: number;
    creditCardUrl: string;
  }> {
    return this.create(`${this.endpoint}${this.PLACE_ORDER_ENDPOINT}`, {
      checkoutCode,
      confirmationEmail,
      deliverSameTime,
      paymentMethod,
      poNumber,
      shippingMethod,
      unit,
      serviceOrder,
      techId,
      mobileNumber,
      emailId,
      isOrderEmailPhoneUpdated,
      OrderTemprary
    });
  }

  public confirmOrder(
    paymentConfirmation: string,
    pendingOrderId: number,
    mobileNumber: string,
    emailId: string,
    isOrderEmailPhoneUpdated: boolean,
    language: string,
    region: string,
    saveCard: boolean
  ): Promise<any> {
    return this.create(`${this.endpoint}${this.CONFIRM_ORDER_ENDPOINT}`, {
      paymentConfirmation,
      pendingOrderId,
      mobileNumber,
      emailId,
      isOrderEmailPhoneUpdated,
      language,
      region,
      saveCard
    });
  }
}

const checkoutServiceInstance = new CheckoutService();
Object.freeze(checkoutServiceInstance);

export default checkoutServiceInstance;
